import { useCallback } from "react";
import { useAppDispatch } from "../hooks";
import { categoryCrud } from "../slices/categorySlice";

interface CategoryCrudProps {
  method: string;
  data: any;
  slug: string | null;
  query: string | null;
}

export const useCategoryRequest = () => {
  const dispatch = useAppDispatch();

  const categoryRequest = useCallback(async ({ method, data, slug, query }: CategoryCrudProps): Promise<any> => {
    const dispatchData = await dispatch(categoryCrud({ method, data, slug, query }));
    return dispatchData;
  }, [dispatch]);

  return categoryRequest;
};
